module.exports = "<app-navigationbar></app-navigationbar>\n<app-header-mask></app-header-mask>\n\n<main>\n  <router-outlet></router-outlet>\n</main>\n\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 216
// module chunks = 1